// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"ce555a31","412":"3bd45373"}[chunkId] + ".chunk.js";
};